import {
  getJson,
  putJson,
  postJson
} from '../fetch';
import { stringifyURLParams } from '../util';
import API_BASE_PATH from './basePath';

export const getExtraSurveyPart = (id) => getJson(`${API_BASE_PATH}/extra-survey-parts/${id}`);

export const getExtraSurveyParts = ({
  type,
  page = 0,
  status,
  keyword,
  filters
} = {}) => {
  const params = stringifyURLParams({
    type,
    page,
    ...(status ? { status } : {}),
    ...(keyword ? { keyword } : {}),
    ...(filters ? { filters } : {})
  });
  return getJson(`${API_BASE_PATH}/extra-survey-parts?${params}`);
};

export const getExtraSurveyPartUsage = (extraPartId) => getJson(`${API_BASE_PATH}/extra-survey-parts/${extraPartId}/usage`);

export const postExtraSurveyPart = (data) => postJson(`${API_BASE_PATH}/extra-survey-parts`, data);

export const putExtraSurveyPart = (extraPartId, data) => putJson(`${API_BASE_PATH}/extra-survey-parts/${extraPartId}`, data);
